import React, { useCallback, useEffect, useId, useState } from 'react';
import InputCheckbox from '../../../StyledComponents/InputCheckbox';

interface QueryFilterProps {
  query: string;
  selected?: boolean;
  loading?: boolean;
  urlSearchParams?: URLSearchParams;
  onFilterUpdate: (query: string) => void;
}

const QueryFilter = ({
  query,
  selected,
  loading,
  urlSearchParams,
  onFilterUpdate,
}: QueryFilterProps) => {
  const checkboxId = useId();
  const [_selected, setSelected] = useState(selected);

  useEffect(() => {
    if (!loading) {
      setSelected(false);
    }
  }, [loading]);

  const onClick = useCallback(() => {
    const nextQuery = new URLSearchParams(urlSearchParams);
    // The free text is `q` in the public API grammar and `query` in the legacy one.
    const key = nextQuery.has('q') ? 'q' : 'query';
    nextQuery.delete('q');
    nextQuery.delete('query');
    if (!selected) {
      nextQuery.set(key, query);
    }

    setSelected(!selected);
    onFilterUpdate(nextQuery.toString());
  }, [query, selected, urlSearchParams]);

  return (
    <InputCheckbox id={checkboxId} onChange={() => onClick()} checked={_selected || selected}>
      &quot;{query}&quot;
    </InputCheckbox>
  );
};

export default QueryFilter;
